// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__eIyxa","icon":"style_icon__kGf2h","dropdownGray":"style_dropdownGray__uYVC-","dropdownDark":"style_dropdownDark__i7k61","title":"style_title__0NYj-"};